module.exports = __webpack_public_path__ + "img/back-top-medal.55409547.png";